import { render } from "./EdoDocumentTitleFlowStep.vue?vue&type=template&id=3d4fe924&scoped=true"
import script from "./EdoDocumentTitleFlowStep.vue?vue&type=script&lang=js"
export * from "./EdoDocumentTitleFlowStep.vue?vue&type=script&lang=js"

import "./EdoDocumentTitleFlowStep.vue?vue&type=style&index=0&id=3d4fe924&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4fe924"]])

export default __exports__